import axios from 'axios';
import { fetchSuccessMock } from '../mocks/success';

const state = {
  fetching: false,
  fetched: false,

  amount: null,
  paymentType: null,
  info: null,
  bankCode: null,
  bankAccount: null,
  deadline: null,
};

const mutations = {
  fetchingStart(state) {
    state.fetching = true;
  },
  fetchingSuccess(state, data) {
    state.fetching = false;
    state.fetched = true;

    state.amount = data.amount;
    state.paymentType = data.paymentType;
    state.info = data.info;
    state.bankCode = data.bankCode;
    state.bankAccount = data.bankAccount;
    state.deadline = data.deadline;
  },
  fetchingError(state) {
    state.fetching = false;
    state.fetched = true;
  },
};

const actions = {
  async fetch({ state, commit }) {
    if (state.fetched) {
      return Promise.resolve();
    }

    commit('fetchingStart');

    try {
      const fetchSuccess = process.env.NODE_ENV === 'development'
        ? await fetchSuccessMock()
        : await axios.get('/success');

      const { data } = fetchSuccess;

      if(data.error) {
        commit('fetchingError', data.message);
        throw new Error(data.message);
      }
      commit('fetchingSuccess', data);
    } catch (error) {
      alert(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
